import { getProtocolAndHost } from '@utils';
import { User, sendEmailVerification } from 'firebase/auth';
import { logError } from '../../../shared/reporting';
import { handleError } from './handleError';

export async function sendEmailVerificationLink(
  user: User,
  redirectTo: string,
  onError: (emailError: string, passwordError: string) => void,
  onSignedIn: () => void,
) {
  try {
    await sendEmailVerification(user, {
      url: `${getProtocolAndHost()}${redirectTo}`,
    });

    onSignedIn();
  } catch (error) {
    const [errorField, errorMsg] = handleError(error);

    if (!errorField) {
      logError(error);
    } else if (errorField === 'email') {
      onError(errorMsg, null);
    } else {
      onError(null, errorMsg);
    }
  }
}
